import { PassengerDetailsRequest } from "@/models/api/PassengerDetailsRequest";
import { PassengerDetailsResponse } from "@/models/api/PassengerDetailsResponse";
import { PassengerDetails } from "@/models/www/PassengerDetails";
import baseApi from "./api.service";

const passengerService = {
	setPassengers(passengerDetails: PassengerDetailsRequest): Promise<void> {
		return baseApi.post<void>("passenger/details", passengerDetails);
	},

	getPassengers(): Promise<PassengerDetails> {
		return new Promise((resolve, reject) => {
			baseApi.get<PassengerDetailsResponse>("passenger/details")
				.then(resp => resolve(new PassengerDetails(resp)))
				.catch(err => reject(err));
		})
	}
}

export default passengerService;